import { lazy } from "react";
import RouteGuard from "../routerPermission";

const AdminCustomer = lazy(() =>
  import("@/pages/vendor/customers").then((m) => ({ default: m.CustomersListPage }))
);

const CustomerRoutes = {
  path: "customers",
  children: [
    {
      path: "",
      element: (
        <RouteGuard resource="customer" action="read">
          <AdminCustomer />
        </RouteGuard>
      ),
    },
  ],
};

export default CustomerRoutes;
